import {
  AverageTransactionValue,
  BusinessActivity,
  CountryCode,
  ExpectedMonthlyRevenue,
  IdentityVerificationStatus,
  SourceOfIncome,
} from "Infrastructure/Api/Api";
import { z } from "zod";

export const verificationValidationSchema = z.object({
  requestedUserID: z.number(),
  businessActivity: z.enum(BusinessActivity).nullish(),
  otherBusinessActivityDetails: z.string().nullish(),
  sourcesOfIncome: z.array(z.enum(SourceOfIncome)).nullish(),
  otherSourceOfIncomeDetails: z.string().nullish(),
  expectedMonthlyRevenue: z.enum(ExpectedMonthlyRevenue).nullish(),
  averageTransactionValue: z.enum(AverageTransactionValue).nullish(),
  isPoliticallyExposedPerson: z.boolean(),
  identityVerificationStatus: z.enum(IdentityVerificationStatus).nullish(), //?
  taxResidency: z.enum(CountryCode).nullish(),
  hasNonEUNationality: z.boolean().nullish(),
  hasNonEUResidence: z.boolean().nullish(),
  uboUnknown: z.boolean(),
});

export type UserVerificationUpdate = z.infer<
  typeof verificationValidationSchema
>;
